define('rebrush/components/blocks/landingpages/router/app',[
    'jquery',
    'cartware/components/_base',
    'cartware/jquery/bem',
    'lodash',
    'scrollreveal'
], function(
    $,
    Component,
    BEM,
    _,
    ScrollReveal
) {
    var BLOCK_NAME = 'lp-router-app';

    function App(block) {
        this.block = BEM.block(block);
        this.elements = this.block.getElements('element');

        this.initScrollreveal();
    }

    App.prototype = {

        initScrollreveal: function() {
            if (this.elements.length) {
                ScrollReveal().reveal(this.elements, {
                    reset: false,
                    scale: 1,
                    opacity: 0
                });
            }

            this.block.css('opacity', 1);
        }

    };

    return Component.create({
        $init: function() {
            BEM.block(BLOCK_NAME).each(function() {
                new App(this);
            });
        }
    });
});
